import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { APP_CONFIG, Settings } from './config/settings';

@Component({
    selector: 'nova-welcome',
    standalone: true,
    template: ` <img
            priority
            [ngSrc]="'assets/images/svg/' + (domain === 'AYA' ? 'aya-logo-primary-full-color.svg' : 'HCS-logo.svg')"
            width="450"
            height="198"
            alt="brand logo" />
        <div class="front-strip">
            <h1>Welcome to {{ domain === 'AYA' ? 'Aya' : 'HCS' }} Nova</h1>
        </div>`,
    styleUrls: ['./welcome.component.scss'],
    imports: [NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeComponent {
    domain: string;

    constructor(@Inject(APP_CONFIG) settings: Settings) {
        this.domain = settings.domain;
    }
}
